import { render } from "./TasksListing.vue?vue&type=template&id=7608131a"
import script from "./TasksListing.vue?vue&type=script&lang=js"
export * from "./TasksListing.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__